import { getCsrfToken } from "../../hooks/useRailsApi";

export async function uploadTempAttachment(file: File): Promise<number | null> {
  const form = new FormData();
  form.append("temp_attachment[upload]", file);

  const response = await fetch("/temp_attachments", {
    method: "POST",
    headers: { "X-CSRF-Token": getCsrfToken() },
    body: form,
  });

  if (!response.ok) return null;
  // process file data if response from server OK
  const data = await response.json().catch(() => null);
  return data?.files?.[0]?.id ?? null;
}
